/**
 * Avatar con iniciales y color estable derivado del identificador.
 */
import type { ReactElement } from 'react';
import { initials } from '../format.ts';

const TONES = ['a', 'b', 'c', 'd', 'e', 'f'] as const;

function toneFor(seed: string): string {
  let hash = 0;
  for (let index = 0; index < seed.length; index += 1) {
    hash = (hash * 31 + seed.charCodeAt(index)) % 9973;
  }
  return TONES[hash % TONES.length] ?? 'a';
}

export function Avatar({
  name,
  seed,
  size = 'md',
}: {
  name: string | null | undefined;
  seed?: string | null;
  size?: 'sm' | 'md' | 'lg';
}): ReactElement {
  const label = name?.trim() || seed?.trim() || '?';
  const tone = toneFor(seed?.trim() || label);
  return (
    <span className={`avatar avatar--${size} avatar--tone-${tone}`} aria-hidden="true">
      {initials(label)}
    </span>
  );
}
